// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"5bdfa5e6","333":"6da72699","460":"bf310b7e","948":"ec8ad640"}[chunkId] + ".chunk.js";
};